import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
type SettingsPathProps = {
  path: string[];
};
export function SettingsPath({
  path
}: SettingsPathProps) {
  return <div className="rounded-2xl bg-mist px-4 py-3" data-id="element-75" data-mp="2yc2lzlej8bzw">
      <p className="text-[11px] font-semibold uppercase tracking-widest text-muted" data-id="element-76" data-mp="3d3lak7lgjeuv">Entrá en</p>
      <ol className="mt-1.5 flex flex-wrap items-center gap-x-1 gap-y-1" data-id="element-77" data-mp="38b1tv1rh43lu">
        {path.map((segment, index) => <li key={segment} className="flex items-center gap-1" data-id="element-78" data-mp="3m1wy20r11wj3" data-mpi={index}>
            {index > 0 && <ChevronRightIcon className="h-3.5 w-3.5 text-muted" aria-hidden="true" data-id="element-79" data-mp="3h3velepovv73" />}
            <span className="text-sm font-semibold text-ink" data-id="element-80" data-mp="3w15owkqliv18">{segment}</span>
          </li>)}
      </ol>
    </div>;
}